import Vue from 'vue';

// App global events
export const BEFORE_SITE_CHANGE_EVENT = 'BEFORE_SITE_CHANGE_EVENT';
export const AFTER_SITE_CHANGE_EVENT = 'AFTER_SITE_CHANGE_EVENT';
export const CONTENT_EDITOR_PREVIEW_TOGGLE = 'CONTENT_EDITOR_PREVIEW_TOGGLE';
export const COMPOSITION_PREVIEW_LOADED = 'COMPOSITION_PREVIEW_LOADED';
export const COMPOSITION_PREVIEW_LOAD_FAILSAFE = 'COMPOSITION_PREVIEW_LOAD_FAILSAFE';
export const COMPOSITION_HARD_RELOAD_PREVIEW = 'COMPOSITION_HARD_RELOAD_PREVIEW';
export const ONBOARDING_DIALOG_CLOSED_EVENT = 'ONBOARDING_DIALOG_CLOSED_EVENT';

export const eventBus = new Vue();
